import { render, staticRenderFns } from "./SalePricesAdditionalServices.vue?vue&type=template&id=507f6e6b&scoped=true"
import script from "./SalePricesAdditionalServices.vue?vue&type=script&lang=js"
export * from "./SalePricesAdditionalServices.vue?vue&type=script&lang=js"
import style0 from "./SalePricesAdditionalServices.vue?vue&type=style&index=0&id=507f6e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f6e6b",
  null
  
)

export default component.exports